var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"locked text-upper flex-center"},[_c('i',{staticClass:"n-i n-i-lock-a"}),_c('span',[_vm._v(_vm._s(_vm._f("translate")(_vm.status)))])])}
var staticRenderFns = []

export { render, staticRenderFns }